import { computed } from 'vue';
import { checkDevice } from '@/utils/game';

export const isPC = computed(() => {
  return checkDevice() === 'other';
});

export const checkDirection = computed(() => {
  const lang = document.documentElement.lang;
  return lang === 'ar' || lang === 'ur' ? 'rtl' : 'ltr';
});

export const isMobile = computed(() => {
  const ua = navigator.userAgent;
  return /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(ua) ||
    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(ua)
});
